<template>
  <div class="footer-breadcrumb">
    <a class="footer-breadcrumb-crumb"
       v-for="breadcrumb in breadcrumbs"
       :key="breadcrumb.text"
       :href="breadcrumb.src"
    >
      > {{ breadcrumb.text }}
    </a>
  </div>
</template>

<script>
export default {
    name: 'FooterBreadcrumb',
    data () {
        return {
            breadcrumbs: [
                { text: 'Entwicklung', src: '' },
                { text: 'Feedback', src: 'https://www.linguasnapp.uni-hamburg.de/feedback.html?local_url=https%3A%2F%2Fmap.www.linguasnapp.uni-hamburg.de%2F' },
                { text: 'Impressum', src: 'https://www.linguasnapp.uni-hamburg.de/imprint.html' },
                { text: 'Datenschutz', src: 'https://www.linguasnapp.uni-hamburg.de/privacypolicy.html' },
                { text: 'Sitemap', src: 'https://www.linguasnapp.uni-hamburg.de/sitemap.html' },
            ],
        };
    },
};
</script>

<style scoped>
.footer-breadcrumb {
  float: left;
}

.footer-breadcrumb-crumb {
  font-weight: 600;
  text-decoration: none;
  margin-left: 20px;
  white-space: nowrap;
}

@media (max-width: 580px) {
  .footer-breadcrumb-crumb {
    white-space: pre;
  }
}
</style>
